import styled from 'styled-components';
import logo from '@/images/logo_white.png';
import { mediaQuery } from '@/styles/media';

const Pc = styled.p`
  ${mediaQuery.sp} {
    display: none;
  }
`;

const Sp = styled.p`
  display: none;

  ${mediaQuery.sp} {
    display: inline;
  }
`;

const FooterLogo: React.FC = () => (
  <>
    <Pc>
      <img src={logo} alt="POSTD PRODUCED BY NIJIBOX" width={160} height={75} />
    </Pc>
    <Sp>
      <img src={logo} alt="POSTD PRODUCED BY NIJIBOX" width={130} height={61} />
    </Sp>
  </>
);

export default FooterLogo;
